export const PROD = true;

export let BASE_URL =
  PROD === true ? `https://ruetmethesis.xyz` : `http://localhost:5000`;
